var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "css-grid sales-chart__container" },
    [
      _vm.showTrend
        ? _c("ChartCustom", {
            staticClass: "chart__trend",
            attrs: { "chart-settings": _vm.chartConfig }
          })
        : _c("span", [
            _c("h3", [_vm._v("Notice:")]),
            _vm._v(
              'Please run a report that includes more than 1 months data to view the trend. You can adjust this using the "Sales Range" filter.'
            )
          ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }